import ButtonLove from "components/Button/ButtonLove"
import Price from "components/Price/Price"
import { observer } from "mobx-react"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { Link } from "react-router-dom"
import { Button, Icon, Segment } from "semantic-ui-react"
import shop from "shop/shop"
import ImageWithFallback from "components/ImageWithFallback"

@observer
export default class ProductListItem extends Component {
  
  render() {
    let { product, categoryId = "", to = "/", referrer = null } = this.props
    const inCart = shop.cart.productsById.get( product.map_id ) || product
    return (
      <Segment
        key={product.map_id}
        className="product db pv3 w-100 ProductListItem relative">
        <div className="flex flex-row w-100 justify-between items-center">
          <div className={"flex flex-row items-center w-100 justify-between"}>
            <div className={"flex flex-row items-center w-100 mw6"}>
              <Link className="pr3" to={`${to}product/${product.map_id}/?category=${categoryId}&referrer=${referrer}`}>
                <ImageWithFallback
                  width={80}
                  fallback={"/image/placeholder.png"}
                  className="img-responsive"
                  src={product.img_src_small}/>
              </Link>
              
              <div className="caption pr3  w-100 mw6">
                {/*<div className="title" title={product.desc.short_des}>{product.title}</div>*/}
                {/*<div className="art-nr black-70">#{product.article_nr}</div>*/}
                
                <div className="f5 b" title={product.desc.short_des}>{product.article_nr}</div>
                <div className="art-nr black-70 f6">{product.desc.short_des}</div>
                {product.extras.BreiteFarbe && <div className="category f6 black-70" title={product.extras.BreiteFarbe}>{product.extras.BreiteFarbe}</div>}
                
                <div className="actions">
                  {(this.props.list) ? <ButtonLove list={this.props.list}
                                                   product={product}><Icon name={"heart"}/></ButtonLove> : null} </div>
              </div>
            </div>
            
            <div className={"pr3 nowrap black-70 f6"}>
              <div>{product.extras.veextrainfo2}</div>
              {product.extras.veextrainfo ? <div> {product.extras.veextrainfo}</div> : <div>&nbsp;</div>}
              {product.extras.statusinfo ? <div> {product.extras.statusinfo}</div> : <div>&nbsp;</div>}
            </div>
            
            {shop.session && <div className="price f6 color pr3 nowrap">
              <b><Price>{product.price}</Price> / {product.extras.Verkaufseinheit}</b>
              <div className="availability black-50">{product.getNotice( "tiny" )}</div>
            </div>}
          
          
          </div>
          
          {this.props.children}
          
          {/*<div className="ve absolute left-1 top-1 black-50">{product.unit_multi} {translate( "piece" )}</div>*/}
          {product.price !== undefined ? <div className={"flex flex-row items-center justify-end"}>
            
            
            <ButtonLove list={shop.orderlist.default}
                        className="dib mr3"
                        elementInActive={<span><Icon name={"heart"}/></span>}
                        elementActive={<span><Icon name={"heart"}/></span>}
                        product={product}/>
            <Button primary className="" basic icon="cart" onClick={() => {
              if ( product.count ) {
                product.count += 1
              } else {
                product.count = 1
              }
              shop.cart.add( product )
              shop.toast( `${product.count} ${product.unit_desc}x ${product.title} ${translate( "im Warenkorb" )}`, "info", false, "bottom" )
            }}/>
          
          </div> : <div className="">
            <Link to={`/login?referrer=${location.pathname}`}> <Button fluid basic>{translate( "Preise anzeigen" )} </Button></Link>
          </div>
          }
        </div>
      
      </Segment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Product/ProductListItem.js